function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.89,283H97V89H249V209.31a4,4,0,0,0,8,0V85a4,4,0,0,0-4-4H213V77a4,4,0,0,0-4-4H137a4,4,0,0,0-4,4v4H93a4,4,0,0,0-4,4V287a4,4,0,0,0,4,4h99.89a4,4,0,0,0,0-8Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,117H149a4,4,0,0,0,0,8h80a4,4,0,0,0,0-8Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,153H149a4,4,0,0,0,0,8h80a4,4,0,0,0,0-8Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,189H149a4,4,0,0,0,0,8h80a4,4,0,0,0,0-8Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,225a43,43,0,1,0,43,43A43,43,0,0,0,252,225Zm0,78a35,35,0,1,1,35-35A35,35,0,0,1,252,303Z",
    style: {
      fill: "#f5882a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.94,260.24,256,264.4V245.47a4,4,0,0,0-8,0v26a4,4,0,0,0,2,3.48,4.06,4.06,0,0,0,2,.52,4,4,0,0,0,2.06-.57l13-7.8a4,4,0,1,0-4.12-6.86Z",
    style: {
      fill: "#f5882a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,117H117a4,4,0,0,0,0,8h16a4,4,0,0,0,0-8Z",
    style: {
      fill: "#f5882a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,153H117a4,4,0,0,0,0,8h16a4,4,0,0,0,0-8Z",
    style: {
      fill: "#f5882a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,189H117a4,4,0,0,0,0,8h16a4,4,0,0,0,0-8Z",
    style: {
      fill: "#f5882a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order-history.d0ea390a31d7f563cb8886a7234d75f6.svg";
export { ForwardRef as ReactComponent };